<template>
    <div class="media-upload-panel" :class="{ 'visible': visible }">
        <!-- 头部工具栏 -->
        <div class="panel-header">
            <div class="left">
                <i class="el-icon-back" @click="handleBack"></i>
                <span class="title">素材上传</span>
            </div>
        </div>

        <!-- 内容区域 -->
        <div class="panel-content">
            <!-- 上传区域 -->
            <div class="upload-section">
                <div class="section-header">
                    <div class="title">
                        <i class="el-icon-circle-plus"></i>
                        <span>上传素材</span>
                    </div>
                </div>
                <div class="section-content">
                    <!-- 上传区域 -->
                    <div class="media-upload-container">
                        <div class="image-actions" v-if="mediaUrl">
                            <el-tooltip content="删除后重新上传" placement="top">
                                <i class="el-icon-delete" @click="handleDeleteMedia()" style="color: #ffffff;"></i>
                            </el-tooltip>
                        </div>
                        <div class="media-upload">
                            <el-upload
                                ref="upload"
                                class="upload-container"
                                action=""
                                :auto-upload="false"
                                :show-file-list="false"
                                :on-change="handleMediaChange"
                                :before-upload="beforeUpload"
                                :limit="1"
                                :multiple="false"
                                accept="image/*,video/mp4,image/gif,application/photoshop,application/x-photoshop,image/vnd.adobe.photoshop,application/psd,image/psd,audio/mpeg,audio/wav">
                                <div class="upload-area">
                                    <template v-if="!mediaUrl">
                                        <div class="upload-content">
                                            <i class="el-icon-plus"></i>
                                            <el-tooltip content="场景尺寸：4096*4096，道具尺寸：2048*2048" placement="top">
                                                <div class="upload-text">点击上传素材</div>
                                            </el-tooltip>
                                            <div class="upload-hint">支持图片、GIF、MP3、MP4、PSD等格式</div>
                                        </div>
                                    </template>
                                    <div v-else class="preview-container">
                                        <div v-if="uploading" class="upload-loading">
                                            <i class="el-icon-loading"></i>
                                            <span>上传中...</span>
                                        </div>
                                        <template v-else>
                                            <!-- 图片预览 -->
                                            <el-image
                                                v-if="mediaType === 'image'"
                                                class="preview-image"
                                                :src="mediaUrl"
                                                fit="contain">
                                            </el-image>
                                            <!-- 视频预览 -->
                                            <video 
                                                v-else-if="mediaType === 'video'"
                                                class="preview-video"
                                                :src="mediaUrl"
                                                controls
                                                autoplay
                                                loop
                                                muted>
                                            </video>
                                            <!-- GIF预览 -->
                                            <el-image
                                                v-else-if="mediaType === 'gif'"
                                                class="preview-image gif-preview"
                                                :src="mediaUrl"
                                                fit="contain">
                                            </el-image>
                                            <!-- PSD预览 -->
                                            <div 
                                                v-else-if="mediaType === 'psd'"
                                                class="psd-preview">
                                                <template>
                                                    <div class="psd-icon">
                                                        <i class="el-icon-document"></i>
                                                        <span>PSD</span>
                                                    </div>
                                                    <div class="psd-filename">{{mediaName}}</div>
                                                    <div class="psd-hint">暂不支持直接预览PSD内容。</div>
                                                </template>
                                            </div>
                                            <!-- 音频预览 -->
                                            <div 
                                                v-else-if="mediaType === 'audio'"
                                                class="audio-preview">
                                                <div class="audio-icon">
                                                    <i class="el-icon-headset"></i>
                                                    <span>{{audioExtension ? audioExtension.toUpperCase() : ''}}</span>
                                                </div>
                                                <div class="audio-filename">{{mediaName}}</div>
                                                <audio 
                                                    controls 
                                                    :src="mediaUrl"
                                                    class="audio-player">
                                                    您的浏览器不支持音频播放。
                                                </audio>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </el-upload>
                        </div>
                    </div>
                    
                    <!-- 表单区域 -->
                    <div class="form-container">
                        <el-form :model="uploadForm" :rules="rules" ref="uploadForm" label-position="top">
                            <el-form-item label="素材名称" prop="fileName">
                                <el-input 
                                    v-model="uploadForm.fileName" 
                                    placeholder="请输入素材名称"
                                    :maxlength="50"
                                    show-word-limit>
                                </el-input>
                            </el-form-item>
                            
                            <el-form-item label="素材类型" prop="resourceType">
                                <el-select 
                                    v-model="uploadForm.resourceType" 
                                    placeholder="请选择素材类型"
                                    style="width: 100%">
                                    <el-option
                                        v-for="item in resourceTypeOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            
                            <el-form-item label="保存位置" prop="folderId">
                                <el-select
                                    v-model="uploadForm.folderId"
                                    placeholder="请选择文件夹"
                                    style="width: 100%"
                                    popper-class="folder-select-dropdown">
                                    <el-option
                                        v-for="item in flattenedDirectory"
                                        :key="item.id"
                                        :label="item.pathName"
                                        :value="item.id">
                                        <span class="folder-path">{{ item.pathName }}</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            
                            <el-form-item>
                                <el-button 
                                    type="primary" 
                                    @click="submitForm" 
                                    :loading="saving"
                                    :disabled="!mediaUrl || uploading"
                                    style="width: 100%">
                                    保存素材
                                </el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Protocol from '@/common/scripts/protocol.js'
import EUY from '@/common/scripts/euy.js'
import { mapState } from 'vuex'
export default {
    name: 'MediaUpload',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: ''
        },
        teamId: {
            type: String,
            default: ''
        },
        folderId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            platform: this.$route.query.platform,
            token: EUY.GetStorage('login_status').tokenId,
            // 上传相关
            mediaUrl: '',
            mediaName: '',
            mediaType: '', // image, video, gif, psd, audio
            audioExtension: '', // mp3, wav
            mediaFile: null,
            uploading: false,
            
            // 表单相关
            uploadForm: {
                fileName: '',
                resourceType: '',
                folderId: ''
            },
            rules: {
                fileName: [
                    { required: true, message: '请输入素材名称', trigger: 'blur' },
                    { max: 50, message: '名称长度不能超过50个字符', trigger: 'blur' }
                ],
                resourceType: [
                    { required: true, message: '请选择素材类型', trigger: 'change' }
                ],
                folderId: [
                    { required: true, message: '请选择保存位置', trigger: 'change' }
                ]
            },
            saving: false,
            
            // 素材类型选项
            resourceTypeOptions: [
                { value: 'scene', label: '场景' },
                { value: 'prop', label: '道具' },
                { value: 'bgm', label: '音乐' },
            ],
            
            // 文件夹相关
            flattenedDirectory: [],
            localFolderId: '', // 本地存储的 folderId，避免直接修改 prop
        };
    },
    computed: {
        
    },
    watch: {
        // 监听素材类型表单字段变化
        'uploadForm.resourceType': {
            immediate: false,
            handler(newType, oldType) {
                console.log('uploadForm.resourceType changed:', newType, oldType);
                if (newType && newType !== oldType) {
                    this.getFolderList(newType, this.teamId);
                }
            }
        },
        // 监听visible属性变化
        visible: {
            handler(newVal) {
                console.log('MediaUpload visible changed:', newVal)
                if (newVal) {
                    this.getFolderList(this.type, this.teamId);
                }
            },
            immediate: true
        },
        // 监听type属性变化
        type: {
            immediate: true,
            handler(newType, oldType) {
                console.log('MediaUpload type changed:', newType, oldType)
                // 将外部传入的type赋值给uploadForm.resourceType
                if (newType) {
                    this.uploadForm.resourceType = newType;
                }
            }
        },
        teamId: {
            handler(newVal, oldVal) {
                console.log('MediaUpload teamId changed:', oldVal, '->', newVal)
                if (this.visible && newVal !== oldVal) {
                    this.getFolderList(this.type, newVal);
                }
            },
            immediate: true
        },
        folderId: {
            handler(newVal) {
                console.log('MediaUpload folderId changed:', newVal)
                this.localFolderId = newVal;
            },
            immediate: true
        }
    },
    methods: {
        // 返回按钮处理
        handleBack() {
            // 清理上传状态
            this.clearUploadCache();
            this.resetForm();
            // 通知父组件关闭
            this.$emit('update:visible', false);
        },
        
        // 文件上传前验证
        beforeUpload(file) {
            console.log('beforeUpload', file);
            const isImage = file.type.startsWith('image/');
            const isVideo = file.type === 'video/mp4';
            const isGif = file.type === 'image/gif';
            const isPsd = file.type === 'application/x-photoshop' || file.type === 'image/vnd.adobe.photoshop' || file.type === 'application/photoshop' || file.type === 'application/psd' || file.type === 'image/psd' || file.name.toLowerCase().endsWith('.psd');
            const isAudio = file.type === 'audio/mpeg' || file.type === 'audio/wav' || file.name.toLowerCase().endsWith('.mp3') || file.name.toLowerCase().endsWith('.wav');
            const isValidFile = isImage || isVideo || isGif || isPsd || isAudio;
            const isLt100M = file.size / 1024 / 1024 < 100;

            if (!isValidFile) {
                this.$message.error('只能上传图片、GIF、MP4视频、PSD或音频文件！');
                return false;
            }
            if (!isLt100M) {
                this.$message.error('文件大小不能超过 100MB！');
                return false;
            }
            return true;
        },
        
        // 文件变更处理
        async handleMediaChange(file) {
            console.log('handleMediaChange', file);
            if (!file || !file.raw) return;

            // 清除之前的状态
            this.mediaUrl = '';
            this.mediaName = '';
            this.mediaType = '';
            this.audioExtension = '';
            this.uploading = true;
            
            const fileType = file.raw.type;
            const fileName = file.raw.name;
            this.mediaFile = file.raw;
            this.mediaName = fileName.substring(0, fileName.lastIndexOf('.')) || fileName;
            
            // 设置上传表单的文件名
            this.uploadForm.fileName = this.mediaName;
            
            // 根据文件类型设置mediaType
            if (fileType === 'video/mp4') {
                this.mediaType = 'video';
            } else if (fileType === 'image/gif') {
                this.mediaType = 'gif';
            } else if (
                fileType === 'application/x-photoshop' || fileType === 'image/vnd.adobe.photoshop' || 
                fileType === 'application/photoshop' || fileType === 'application/psd' || 
                fileType === 'image/psd' || fileName.toLowerCase().endsWith('.psd')
            ) {
                this.mediaType = 'psd';
                // PSD文件大小限制
                if (file.raw.size > 100 * 1024 * 1024) {
                    this.$message.error('PSD文件大小不能超过100MB，以避免服务器处理问题');
                    this.uploading = false;
                    return;
                }
            } else if (
                fileType === 'audio/mpeg' || fileType === 'audio/mp3' || fileName.toLowerCase().endsWith('.mp3')
            ) {
                this.mediaType = 'audio';
                this.audioExtension = 'mp3';
            } else if (
                fileType === 'audio/wav' || fileType === 'audio/x-wav' || fileName.toLowerCase().endsWith('.wav')
            ) {
                this.mediaType = 'audio';
                this.audioExtension = 'wav';
            } else if (fileType.startsWith('image/')) {
                this.mediaType = 'image';
            } else {
                throw new Error('不支持的文件类型');
            }

            try {
                // 显示本地预览
                if (this.mediaType === 'psd') {
                    // 显示占位和文件名
                    this.mediaUrl = URL.createObjectURL(file.raw);
                } else if (this.mediaType === 'audio') {
                    // 显示音频播放器和文件名
                    this.mediaUrl = URL.createObjectURL(file.raw);
                } else {
                    this.mediaUrl = URL.createObjectURL(file.raw);
                }
                this.mediaName = file.name;
                
                // 自动设置文件名（不带扩展名）
                const lastDotIndex = file.name.lastIndexOf('.');
                const nameWithoutExt = lastDotIndex > 0 ? file.name.substring(0, lastDotIndex) : file.name;
                this.uploadForm.fileName = nameWithoutExt;
                
                // 自动设置资源类型
                if (this.mediaType === 'audio') {
                    this.uploadForm.resourceType = 'bgm';
                } else if (this.mediaType === 'gif') {
                    this.uploadForm.resourceType = 'prop';
                } else if (this.mediaType === 'video') {
                    this.uploadForm.resourceType = 'prop';
                }

                // 构建上传数据
                const formData = new FormData();
                formData.append('file', file.raw);
                formData.append('type', 'none');
                formData.append('ownerId', this.teamId);

                const response = await this.uploadFile(formData);
                
                if (response.code === 10000) {
                    this.mediaUrl = response.datas.url;
                    this.mediaFile = response.datas;
                    this.$message.success('上传成功');
                } else {
                    throw new Error(response.message || '上传失败');
                }
            } catch (error) {
                this.$message.error(error.message || '上传失败，请重试');
                this.clearUploadCache();
            } finally {
                this.uploading = false;
                //上传后清除上传组件的文件,避免二次上传失效
                this.$refs.upload.clearFiles();
            }
        },
        
        // 上传文件到服务器
        async uploadFile(formData) {
            const URL = process.env.HOST + '/api/storage/storage/upload';
            const headers = {
                'Authorization': this.token
            };
            
            try {
                const response = await this.AJAX.post(URL, headers, formData);
                return response;
            } catch (error) {
                console.error('文件上传失败:', error);
                throw error;
            }
        },
        
        // 清除上传缓存
        clearUploadCache() {
            this.mediaUrl = '';
            this.mediaName = '';
            this.mediaType = '';
            this.audioExtension = '';
            this.mediaFile = null;
            this.$refs.upload.clearFiles();
        },
        
        // 删除已上传的媒体
        handleDeleteMedia() {
            this.clearUploadCache();
            this.uploading = false;
        },
        
        // 获取文件夹列表
        async getFolderList(type, team_id) {
            try {
                const URL = process.env.HOST + '/pro/api/ResourceFolder/folderTree';
                const headers = {
                    'token': this.token,
                };
                
                const formData = new FormData();
                formData.append('type', type);
                formData.append('team_id', team_id); 
                
                const response = await this.AJAX.post(URL, headers, formData);
                if (response.code === 0) {
                    // 将树形结构扁平化，并添加完整路径名
                    this.flattenedDirectory = this.flattenDirectoryTree(response.result);
                    
                    if(this.localFolderId){
                        this.$nextTick(() => {
                            this.uploadForm.folderId = this.localFolderId;
                            this.localFolderId = '';
                        });
                    }else{
                        // 设置默认选中第一个值
                        if (this.flattenedDirectory && this.flattenedDirectory.length > 0) {
                            this.$nextTick(() => {
                                this.uploadForm.folderId = this.flattenedDirectory[0].id;
                            });
                        }
                    }
                } else {
                    throw new Error(response.msg || '获取文件夹列表失败');
                }
            } catch (error) {
                console.error('获取文件夹列表失败:', error);
                this.$message.error(error.message || '获取文件夹列表失败，请重试');
            }
        },
        
        // 扁平化目录树
        flattenDirectoryTree(tree, parentPath = '') {
            let result = [];
            tree.forEach(node => {
                const currentPath = parentPath ? `${parentPath} / ${node.label}` : node.label;
                result.push({
                    id: node.id,
                    label: node.label,
                    pathName: currentPath
                });
                if (node.children && node.children.length > 0) {
                    result = result.concat(this.flattenDirectoryTree(node.children, currentPath));
                }
            });
            return result;
        },
        
        // 提交表单
        submitForm() {
            this.$refs.uploadForm.validate(async (valid) => {
                if (valid) {
                    await this.saveMedia();
                }
            });
        },
        
        // 保存媒体文件
        async saveMedia() {
            if (this.saving || !this.mediaFile) return;
            
            this.saving = true;
            try {
                const URL = process.env.HOST + '/api/storage/storage/resource/v1/save';
                const formData = new FormData();
                formData.append('type', this.uploadForm.resourceType);
                formData.append('teamId', this.teamId); 
                formData.append('folderId', this.uploadForm.folderId); 
                formData.append('fileUrl', this.mediaUrl); 
                formData.append('title', this.uploadForm.fileName);
                
                const headers = {
                    'Authorization': this.token
                };

                const response = await this.AJAX.post(URL, headers, formData);
                
                if (response.code === 10000) {
                    this.$message.success('保存成功');
                    this.clearUploadCache();
                    this.resetForm();
                    // 关闭组件
                    this.$emit('update:visible', false);
                    // 通知父组件刷新资源列表
                    this.$emit('refresh');
                } else {
                    throw new Error(response.message || '保存失败');
                }
            } catch (error) {
                this.$message.error(error.message || '保存失败，请重试');
            } finally {
                this.saving = false;
            }
        },
        
        // 重置表单
        resetForm() {
            this.clearUploadCache();
            this.uploadForm.fileName = '';
            this.uploadForm.resourceType = '';
            this.uploadForm.folderId = '';
            this.flattenedDirectory = [];
            this.$nextTick(() => {
                this.$refs.uploadForm && this.$refs.uploadForm.resetFields();
            });
        }
    },
    mounted() {
        let _this = this;
        let platform = this.$route.query.platform;
        window[TOOLBAR_NAME] = {}
        window[TOOLBAR_NAME].init = () => {
            this.token = window[TOOLBAR_NAME].token;
        }
    },
    beforeDestroy() {
        // 组件销毁前的清理操作
        this.clearUploadCache();
    }
}
</script>

<style lang="stylus" scoped>
/* 视频预览样式 */
.preview-video
    width: 100%
    height: 100%
    object-fit: contain

/* GIF预览特殊样式 */
.gif-preview
    width: 100%
    height: 100%
/* 预览psd */
.psd-preview
    width: 100%
    height: 100%
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    text-align: center
    background: #f5f5f5
    border-radius: 4px
    
    .psd-icon
        margin-bottom: 10px
        
        i
            font-size: 48px
            color: #409EFF
            margin-bottom: 5px
            display: block
            
        span
            font-size: 14px
            color: #409EFF
            font-weight: bold
    
    .psd-filename
        font-size: 12px
        color: #333
        margin-bottom: 8px
        word-break: break-all
        max-width: 120px
        
    .psd-hint
        font-size: 10px
        color: #999
        line-height: 1.4

.media-upload-panel
    position: fixed
    top: 0
    right: -100%
    width: 500px
    height: 100vh
    background: #212121
    transition: right 0.3s ease-in-out
    z-index: 1000
    display: flex
    flex-direction: column

    &.visible
        right: 0

    .panel-header
        height: 60px
        padding: 0 20px
        background: #303030
        display: flex
        align-items: center
        justify-content: space-between

        .left
            display: flex
            align-items: center
            
            i
                font-size: 20px
                color: #fff
                cursor: pointer
                margin-right: 10px
                
            .title
                color: #fff
                font-size: 16px

        .right
            display: flex
            align-items: center
            gap: 10px

    .panel-content
        flex: 1
        overflow-y: auto
        padding: 20px

        .upload-section
            margin-bottom: 20px
            background: #fff
            border-radius: 8px
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1)
            
            .section-header
                padding: 10px 15px
                display: flex
                justify-content: center
                align-items: center
                cursor: pointer
                border-bottom: 1px solid #eee
                position: relative
                
                .title
                    font-size: 14px
                    font-weight: 500
                    display: flex
                    align-items: center
                    gap: 8px
                    
                    i
                        font-size: 16px
                        color: #409EFF
                
                i.el-icon-arrow-down
                    position: absolute
                    right: 15px
                    transition: transform 0.3s
                    
                    &.is-active
                        transform: rotate(180deg)
            
            .section-content
                padding: 10px
                padding-top: 5px
                .media-upload-container
                    display: flex
                    flex-direction: column
                    gap: 5px
                    align-items: center
                    
                    .image-actions
                        display: flex
                        gap: 10px
                        background: rgba(0, 0, 0, 0.5)
                        padding: 5px 10px
                        border-radius: 4px
                        
                        i
                            font-size: 16px
                            cursor: pointer
                            color: #ffffff
                            
                            &:hover
                                color: #409EFF
                    
                    .media-upload
                        width: 150px
                        height: 150px
                        
                        .upload-container
                            width: 100%
                            height: 100%
                            
                            .upload-area
                                width: 100%
                                height: 100%
                                border: 1px dashed #d9d9d9
                                border-radius: 6px
                                display: flex
                                justify-content: center
                                align-items: center
                                transition: all 0.3s
                                
                                &:hover
                                    border-color: #409EFF
                                    
                                .upload-content
                                    display: flex
                                    flex-direction: column
                                    justify-content: center
                                    align-items: center
                                    gap: 10px
                                    width: 150px
                                    height: 150px
                                    
                                    .el-icon-plus
                                        font-size: 28px
                                        color: #8c939d
                                    
                                    .upload-text
                                        font-size: 12px
                                        color: #8c939d
                            
                            .preview-container
                                width: 150px
                                height: 150px
                                position: relative
                                
                                .upload-loading
                                    width: 100%
                                    height: 100%
                                    display: flex
                                    justify-content: center
                                    align-items: center
                                    background: rgba(255,255,255,0.8)
                                    
                                    .el-icon-loading
                                        font-size: 24px
                                        color: #409EFF
                                
                                .preview-image
                                    width: 100%
                                    height: 100%
                                    display: block
                                .image-actions
                                    position: absolute
                                    top: 10px
                                    right: 10px
                                    display: flex
                                    gap: 10px
                                    opacity: 0
                                    transition: opacity 0.3s
                                    background: rgba(0, 0, 0, 0.5)
                                    padding: 5px 10px
                                    border-radius: 4px
                                    
                                    i
                                        font-size: 16px
                                        cursor: pointer
                                        color: #ffffff
                                        transition: color 0.3s
                                        
                                        &:hover
                                            color: #409EFF
                                
                                &:hover
                                    .image-actions
                                        opacity: 1
    // 添加到 <style> 标签外
    /deep/ .folder-select-dropdown
        .el-select-dropdown__item
            padding-right: 20px
            .folder-path
                color: #909399
                font-size: 12px
</style>



// WEBPACK FOOTER //
// MediaUpload.vue?4a3d0002